import { render } from "./FadingAlert.vue?vue&type=template&id=284cd038&scoped=true"
import script from "./FadingAlert.vue?vue&type=script&lang=js"
export * from "./FadingAlert.vue?vue&type=script&lang=js"

import "./FadingAlert.vue?vue&type=style&index=0&id=284cd038&scoped=true&lang=css"

import exportComponent from "/home/cherry/safer_pet/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284cd038"]])

export default __exports__